import moment from "moment";

const date = v => !v || moment(v).isValid();

export default date;
